import { useCallback, useLayoutEffect } from 'react';

export function largestSquareInRow(rowWidth, rowHeight, tileCount, gap) {
  if (!tileCount) return 0;
  const widthShare = (rowWidth - (tileCount - 1) * gap) / tileCount;
  return Math.max(0, Math.floor(Math.min(rowHeight, widthShare)));
}

// CSS cannot take the smaller of a row's height and a tile's share of its width, so the row is
// measured and publishes the side length its tiles should use.
export function usePoolTileSize(bandRef, tileSizeVar) {
  const apply = useCallback(() => {
    const band = bandRef.current;
    if (!band) return;
    for (const row of band.children) {
      const tileCount = Number(row.dataset.rowCount) || 0;
      const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      const side = largestSquareInRow(row.clientWidth, row.clientHeight, tileCount, gap);
      if (side > 0) row.style.setProperty(tileSizeVar, `${side}px`);
    }
  }, [bandRef, tileSizeVar]);

  useLayoutEffect(() => {
    const band = bandRef.current;
    if (!band) return undefined;
    apply();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(apply);
    observer.observe(band);
    return () => observer.disconnect();
  }, [bandRef, apply]);
}
